import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const updatePhoneNumberContextActions = createDataModuleActions(
    'UPDATE_PHONE_NUMBER_CONTEXT',
);
export const updatePhoneNumberContext =
    updatePhoneNumberContextActions.dataRequest;
export const updatePhoneNumberContextSuccess =
    updatePhoneNumberContextActions.dataSuccess;
export const updatePhoneNumberContextError =
    updatePhoneNumberContextActions.dataError;
export const updatePhoneNumberContextReset =
    updatePhoneNumberContextActions.dataReset;

const updatePhoneNumberDataModuleActions = createDataModuleActions(
    'UPDATE_PHONE_NUMBER',
);
export const updatePhoneNumber = updatePhoneNumberDataModuleActions.dataRequest;
export const updatePhoneNumberSuccess =
    updatePhoneNumberDataModuleActions.dataSuccess;
export const updatePhoneNumberError =
    updatePhoneNumberDataModuleActions.dataError;

const verifyNewPhoneNumberContextActions = createDataModuleActions(
    'VERIFY_NEW_PHONE_NUMBER_CONTEXT',
);
export const verifyNewPhoneNumberContext =
    verifyNewPhoneNumberContextActions.dataRequest;
export const verifyNewPhoneNumberContextSuccess =
    verifyNewPhoneNumberContextActions.dataSuccess;
export const verifyNewPhoneNumberContextError =
    verifyNewPhoneNumberContextActions.dataError;
export const verifyNewPhoneNumberContextReset =
    verifyNewPhoneNumberContextActions.dataReset;

const verifyNewPhoneNumberDataModuleActions = createDataModuleActions(
    'VERIFY_NEW_PHONE_NUMBER',
);
export const verifyNewPhoneNumber =
    verifyNewPhoneNumberDataModuleActions.dataRequest;
export const verifyNewPhoneNumberSuccess =
    verifyNewPhoneNumberDataModuleActions.dataSuccess;
export const verifyNewPhoneNumberError =
    verifyNewPhoneNumberDataModuleActions.dataError;
